import {createApp} from 'vue'
import Buefy from 'buefy'
import {buefyConfig, keepalive, reloadPageIfCached} from "./ts/utils.js";
import PopupLauncher from "./pages/PopupLauncher.vue";

// EAUTH2-232
reloadPageIfCached()

const app = createApp(PopupLauncher);

//@ts-ignore
app.use(Buefy, buefyConfig)
app.mount('#app')

keepalive(false)
